// extracted by mini-css-extract-plugin
export default {"list":"TabList_list__OMxGW"};